import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { apiBaseUrl } from "@/api/service";
export default {
  name: "quarter-contract-list",
  data: function data() {
    return {
      apiBaseUrl: apiBaseUrl,
      addRules: {
        partyA: [{
          required: true,
          message: "请输入合同甲方",
          trigger: "blur"
        }],
        subjectCompany: [{
          required: true,
          message: "请选择主体公司",
          trigger: "change"
        }],
        orderAmount: [{
          required: true,
          message: "请输入订单金额",
          trigger: "blur"
        }, {
          pattern: /^(0|\d+(\.\d{1,2})?)$/,
          message: "请输入正确的金额格式，最多两位小数",
          trigger: "blur"
        }],
        depositAmount: [{
          required: true,
          message: "请输入押金金额",
          trigger: "blur"
        }, {
          pattern: /^(0|\d+(\.\d{1,2})?)$/,
          message: "请输入正确的金额格式，最多两位小数",
          trigger: "blur"
        }]
      },
      searchForm: {
        current: 1,
        size: 20,
        partyA: '',
        subjectCompany: '',
        status: '',
        contractNumber: ''
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      // 弹窗相关数据
      dialogVisible: false,
      dialogTitle: "新增合同",
      isEdit: false,
      formData: {
        partyA: "",
        subjectCompany: "",
        depositAmount: "",
        // 押金金额
        orderAmount: "",
        // 订单金额
        fileUrls: [] // 合同上传七牛后的 url
      },
      fileList: [],
      dataObj: {
        token: "",
        key: ""
      },
      uploading: false
    };
  },
  mounted: function mounted() {
    this.$route.query.contractNumber && (this.searchForm.contractNumber = this.$route.query.contractNumber);
    this.getData();
  },
  computed: {
    action: function action() {
      return 'https://up-z2.qiniup.com';
    }
  },
  methods: {
    pageChange: function pageChange(current) {
      this.searchForm.current = current;
      this.getData();
    },
    getData: function getData(type) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (type === "search") {
                _this.searchForm.current = 1;
                _this.total = 0;
              }
              _this.tableLoading = true;
              _context.p = 1;
              _context.n = 2;
              return _this.$api.getSigningList(_this.searchForm);
            case 2:
              res = _context.v;
              _this.tableData = res.data.content || [];
              _this.total = res.data.totalSize || 0;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error("获取签约列表失败", _t);
            case 4:
              _context.p = 4;
              _this.tableLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }))();
    },
    // 打开编辑弹窗
    editItem: function editItem(row) {
      this.isEdit = true;
      this.dialogTitle = "编辑合同";
      this.dialogVisible = true;
      this.formData = JSON.parse(JSON.stringify(row));
      this.fileList = row.fileUrls || [];
    },
    // 打开新增弹窗
    openDialog: function openDialog() {
      this.isEdit = false;
      this.dialogTitle = "新增合同";
      this.dialogVisible = true;
      this.resetForm();
    },
    // 重置表单
    resetForm: function resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      this.formData = {
        partyA: "",
        subjectCompany: "",
        depositAmount: "",
        orderAmount: "",
        fileUrls: []
      };
      this.fileList = [];
    },
    handleRemove: function handleRemove(index) {
      this.fileList.splice(index, 1);
      this.formData.fileUrls.splice(index, 1);
      // 触发表单验证
      if (this.$refs.form) {
        this.$refs.form.validateField('fileUrls');
      }
    },
    previewFile: function previewFile(url) {
      window.open(url, '_blank');
    },
    beforeUpload: function beforeUpload(file) {
      var _this2 = this;
      var fileName = file.name;
      var fileType = fileName.substring(fileName.lastIndexOf('.'));
      if (!".pdf,.docx,.doc".includes(fileType)) {
        this.$message.error('请上传正确的文件类型');
        return false;
      }
      var self = this;
      return new Promise(function (resolve, reject) {
        _this2.$api.getQiniuToken({
          multimediaType: 'wellceeContracts'
        }).then(function (res) {
          var key = file.uid;
          var token = res.data[0];
          self._data.dataObj.token = token;
          self._data.dataObj.key = key;
          self.uploading = true;
          resolve(true);
        }).catch(function (err) {
          console.log(err);
          reject(false);
        });
      });
    },
    uploadSuccess: function uploadSuccess(res, file, fileList) {
      if (res.code == 200) {
        this.fileList.push(res.data.url);
        // this.fileList = [res.data.url];
        this.formData.fileUrls = this.fileList;
        // 触发表单验证
        this.$refs.form.validateField('fileUrls');
      } else {
        fileList.forEach(function (item, index) {
          if (file.uid == item.uid) {
            fileList.splice(index, 1);
          }
        });
        this.$message.error(res.msg);
      }
      this.uploading = false;
    },
    uploadChange: function uploadChange(file, fileList) {
      if (file.response && file.response.code == 200) {
        file.loading = false;
      } else {
        file.loading = true;
      }
    },
    // 提交表单
    submitForm: function submitForm() {
      var _this3 = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var res, _t2;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (!valid) {
                  _context2.n = 8;
                  break;
                }
                _context2.p = 1;
                _this3.formData.fileUrls = _this3.fileList;
                if (!_this3.isEdit) {
                  _context2.n = 3;
                  break;
                }
                _context2.n = 2;
                return _this3.$api.editSigning(_this3.formData);
              case 2:
                res = _context2.v;
                _context2.n = 5;
                break;
              case 3:
                _context2.n = 4;
                return _this3.$api.saveSigning(_this3.formData);
              case 4:
                res = _context2.v;
              case 5:
                if (res.code === 200) {
                  _this3.$message.success(_this3.isEdit ? "编辑成功" : "新增成功");
                  _this3.dialogVisible = false;
                  _this3.getData();
                } else {
                  _this3.$message.error(res.msg || (_this3.isEdit ? "编辑失败" : "新增失败"));
                }
                _context2.n = 7;
                break;
              case 6:
                _context2.p = 6;
                _t2 = _context2.v;
                console.error(_this3.isEdit ? "编辑合同失败" : "新增合同失败", _t2);
                _this3.$message.error(_this3.isEdit ? "编辑失败" : "新增失败");
              case 7:
                _context2.n = 9;
                break;
              case 8:
                _this3.$message.warning("请完善表单信息");
                return _context2.a(2, false);
              case 9:
                return _context2.a(2);
            }
          }, _callee2, null, [[1, 6]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};